import React from 'react';

import sendIcon from '../../icons/sendIcon.webp';

import './Input.css';

const Input = ({ setMessage, sendMessage, message }) => (
  <form className="form">
    <input
      className="input"
      type="text"
      placeholder="Type a message..."
      value={message}
      onChange={({ target: { value } }) => setMessage(value)}
      onKeyPress={event => event.key === 'Enter' ? sendMessage(event) : null}
    />
    <button className="sendButton" onClick={e => sendMessage(e)}>
        <img className="sendIcon" src={sendIcon} alt="send icon" />
    </button>
  </form>
)

export default Input;